const forge = require('node-forge')

const publicKey = forge.pki.publicKeyFromPem(process.env.REACT_APP_KEY_PUBLIC)

export default msg => {
  const encrypted = publicKey.encrypt(msg, 'RSA-OAEP', {
    md: forge.md.sha256.create(),
    mgf1: forge.mgf1.create()
  })
  return forge.util.encode64(encrypted)
}